<div class="bulletin-board">
  <div class="title-container">
    <span class="title">Bulletin Board</span>
    <app-new-button
      *ngIf="permissions.EDIT_BULLETIN_BOARD === 1"
      (clickHandler)="addNewPost()"
      leftIcon="add"
      size="sm"
      color="blue"
      customPadding="12px 16px"
    >
      New Post
    </app-new-button>
  </div>
  <app-loading-spinner class="spinner" *ngIf="isLoading"></app-loading-spinner>
  <div *ngIf="!isLoading" class="content">
    <div class="subtitle-container">
      <mat-icon class="material-icons-outlined article-icon">article</mat-icon>
      <span>Latest Posts</span>
    </div>
    <div class="posts-container">
      <div (click)="goToPost(post)" class="post" *ngFor="let post of posts" tabindex="0">
        <div class="post-time-container">
          <span class="date">{{ getPostTime(post) }}</span>
        </div>
        <div class="post-title-container">
          <span class="post-title">{{ post?.title }}</span>
        </div>
        <div class="post-content-container">
          <div class="post-content-cover"></div>
          <app-rich-text-presenter [content]="post.content"></app-rich-text-presenter>
        </div>
      </div>
      <div class="post-content-container" *ngIf="posts.length === 0 || !posts">
        <div class="post">
          <span class="post-title">Currently No Posts Exist</span>
        </div>
      </div>
    </div>
  </div>
</div>
